import * as Types from '@aeppic/types'

import { ComponentSourceGenerator } from '@aeppic/dynamic-components-v3'
import { runDynamicCode } from  '@aeppic/shared/dynamic/dynamic-code'
import * as FieldParams from '../field-params.js'

import { NamedExports } from '../packages/types.js'
import createControllerClass from  '../create-controller-class.js'

export interface ComponentDefinition {
  type: string
  name: string
  identifier: string
  packages: {
    modules: NamedExports
    components: NamedExports
  },
  document: Types.Document
  variablesToExpose: string // In addition to 'locals'
  globals?,
  componentSourceTemplate: string,
}

class EmptyControllerClass {}
class FailedControllerClass {
  private note = 'Placeholder controller due to compile error'
}

const DYNAMIC_COMPONENT_BUILD_LOG = []

export function getDynamicComponentBuildLog() {
  return DYNAMIC_COMPONENT_BUILD_LOG
}

export function clearDynamicComponentBuildLog() {
  DYNAMIC_COMPONENT_BUILD_LOG.length = 0
}

export class DynamicComponentBuilder {

  constructor(private componentDefinition: ComponentDefinition) {
    const logEntry = { at: Date.now(), id: this.componentDefinition.document.id, v: this.componentDefinition.document.v, type: this.componentDefinition.type, name: this.componentDefinition.name }
    DYNAMIC_COMPONENT_BUILD_LOG.push(logEntry) 
  }

  public build() {
    const name = this.componentDefinition.name
    const identifier = this.componentDefinition.identifier
    const variablesToExpose = this.componentDefinition.variablesToExpose
    const packages = this.componentDefinition.packages
    
    const codeGroup = `ae-${this.componentDefinition.type}s`

    const sourceGenerator = new ComponentSourceGenerator(this.componentDefinition)
    const sources = sourceGenerator.generate()

    const parts: any = {
      css: sources.css
    }

    const globals = {
      packages: packages.modules
    }

    const definitionDocumentName = `${this.componentDefinition.type}Document`
    globals[definitionDocumentName] = this.componentDefinition.document

    let controllerClass = null

    if (sources.controller) {
      controllerClass = createControllerClass(`${codeGroup}/controllers`, name, sources.controller, variablesToExpose, globals)
      
      if (controllerClass == null) {
        controllerClass = FailedControllerClass
      }
    }

    if (controllerClass == null) {
      controllerClass = EmptyControllerClass
    }

    const componentGlobals = {
      components: packages.components,
      packages: packages.modules,
      controllerClass,
      FieldParams,
      createControllerAeppic: (baseAeppic, queryRoot?) => {
        const contextName = `${codeGroup}/controllers/${this.componentDefinition.document.id}:${name}`

        if (!baseAeppic || typeof baseAeppic.contextify !== 'function') {
          return baseAeppic
        }

        const controllerAeppic = baseAeppic.contextify(contextName, queryRoot)
        const baseRootElement = baseAeppic.context?.rootElement

        if (baseRootElement && controllerAeppic?.context) {
          controllerAeppic.context.rootElement = baseRootElement
        }

        return controllerAeppic
      },
    }
    componentGlobals[definitionDocumentName] = this.componentDefinition.document
    
    parts.component = runDynamicCode(`${codeGroup}/components`, name, sources.component, componentGlobals)
    return parts
  }
}
